export var SLICE = "reportsCenter";
var SEARCH_REPORTS = "".concat(SLICE, "/SEARCH_REPORTS");
export var SEARCH_REPORTS_REQUEST = "".concat(SEARCH_REPORTS, "_REQUEST");
export var SEARCH_REPORTS_SUCCESS = "".concat(SEARCH_REPORTS, "_SUCCESS");
export var SEARCH_REPORTS_FAILURE = "".concat(SEARCH_REPORTS, "_FAILURE");
var DOWNLOAD_REPORT = "".concat(SLICE, "/DOWNLOAD_REPORT");
export var DOWNLOAD_REPORT_REQUEST = "".concat(DOWNLOAD_REPORT, "_REQUEST");
export var DOWNLOAD_REPORT_SUCCESS = "".concat(DOWNLOAD_REPORT, "_SUCCESS");
export var DOWNLOAD_REPORT_FAILURE = "".concat(DOWNLOAD_REPORT, "_FAILURE");
var GET_TERM_REPORT_CONFIGS = "".concat(SLICE, "/GET_TERM_REPORT_CONFIGS");
export var GET_TERM_REPORT_CONFIGS_REQUEST = "".concat(GET_TERM_REPORT_CONFIGS, "_REQUEST");
export var GET_TERM_REPORT_CONFIGS_SUCCESS = "".concat(GET_TERM_REPORT_CONFIGS, "_SUCCESS");
export var GET_TERM_REPORT_CONFIGS_FAILURE = "".concat(GET_TERM_REPORT_CONFIGS, "_FAILURE");
// LP Selection
export var SELECT_LP = "".concat(SLICE, "/SELECT_LP");
export var SET_SEARCH_REPORTS_PAGE_SIZE = "".concat(SLICE, "/SET_SEARCH_REPORTS_PAGE_SIZE");
export var SET_CURRENT_FOLDER_PATH = "".concat(SLICE, "/SET_CURRENT_FOLDER_PATH");
export var SET_CURRENT_PAGE = "".concat(SLICE, "/SET_CURRENT_PAGE");
export var RESET_IS_TRIGGER_SEARCH_REPORT = "".concat(SLICE, "/RESET_IS_TRIGGER_SEARCH_REPORT");
export var SET_REPORT_SELECTION = "".concat(SLICE, "/SET_REPORT_SELECTION");
export var SET_SORT_CRITERIA = "".concat(SLICE, "/SET_SORT_CRITERIA");
export var RESET_REPORT_LIST = "".concat(SLICE, "/RESET_REPORT_LIST");
export var SET_FILTER_SHEET_OPEN = "".concat(SLICE, "/SET_FILTER_SHEET_OPEN");
export var SET_FILTERS = "".concat(SLICE, "/SET_FILTERS");
var INITIATE_BULK_UPLOAD_FILES = "".concat(SLICE, "/INITIATE_BULK_UPLOAD_FILES");
export var INITIATE_BULK_UPLOAD_FILES_REQUEST = "".concat(INITIATE_BULK_UPLOAD_FILES, "_REQUEST");
export var INITIATE_BULK_UPLOAD_FILES_SUCCESS = "".concat(INITIATE_BULK_UPLOAD_FILES, "_SUCCESS");
export var INITIATE_BULK_UPLOAD_FILES_FAILURE = "".concat(INITIATE_BULK_UPLOAD_FILES, "_FAILURE");
var FILE_PARTS_UPLOAD = "".concat(SLICE, "/FILE_PARTS_UPLOAD");
export var FILE_PARTS_UPLOAD_REQUEST = "".concat(FILE_PARTS_UPLOAD, "_REQUEST");
export var FILE_PARTS_UPLOAD_SUCCESS = "".concat(FILE_PARTS_UPLOAD, "_SUCCESS");
export var FILE_PARTS_UPLOAD_FAILURE = "".concat(FILE_PARTS_UPLOAD, "_FAILURE");
var COMPLETE_BULK_UPLOAD_FILES = "".concat(SLICE, "/COMPLETE_BULK_UPLOAD_FILES");
export var COMPLETE_BULK_UPLOAD_FILES_REQUEST = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_REQUEST");
export var COMPLETE_BULK_UPLOAD_FILES_SUCCESS = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_SUCCESS");
export var COMPLETE_BULK_UPLOAD_FILES_FAILURE = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_FAILURE");
export var RESET_BULK_FILES_PART_STATE = "".concat(SLICE, "/RESET_BULK_FILES_PART_STATE");
var UPLOAD_FILE_FOLDER = "".concat(SLICE, "/UPLOAD_FILE_FOLDER");
export var UPLOAD_FILE_FOLDER_REQUEST = "".concat(UPLOAD_FILE_FOLDER, "_REQUEST");
export var UPLOAD_FILE_FOLDER_SUCCESS = "".concat(UPLOAD_FILE_FOLDER, "_SUCCESS");
export var UPLOAD_FILE_FOLDER_FAILURE = "".concat(UPLOAD_FILE_FOLDER, "_FAILURE");
var DELETE_REPORT = "".concat(SLICE, "/DELETE_REPORT");
export var DELETE_REPORT_REQUEST = "".concat(DELETE_REPORT, "_REQUEST");
export var DELETE_REPORT_SUCCESS = "".concat(DELETE_REPORT, "_SUCCESS");
export var DELETE_REPORT_FAILURE = "".concat(DELETE_REPORT, "_FAILURE");
var BULK_DOWNLOAD_REPORTS = "".concat(SLICE, "/BULK_DOWNLOAD_REPORTS");
export var BULK_DOWNLOAD_REPORTS_REQUEST = "".concat(BULK_DOWNLOAD_REPORTS, "_REQUEST");
export var BULK_DOWNLOAD_REPORTS_SUCCESS = "".concat(BULK_DOWNLOAD_REPORTS, "_SUCCESS");
export var BULK_DOWNLOAD_REPORTS_FAILURE = "".concat(BULK_DOWNLOAD_REPORTS, "_FAILURE");
var GENERATE_REPORT_ASYNC = "".concat(SLICE, "/GENERATE_REPORT_ASYNC");
export var GENERATE_REPORT_ASYNC_REQUEST = "".concat(GENERATE_REPORT_ASYNC, "_REQUEST");
export var GENERATE_REPORT_ASYNC_SUCCESS = "".concat(GENERATE_REPORT_ASYNC, "_SUCCESS");
export var GENERATE_REPORT_ASYNC_FAILURE = "".concat(GENERATE_REPORT_ASYNC, "_FAILURE");
export var RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC = "".concat(SLICE, "/RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC");
export var PREVIEW_ENABLED = "".concat(SLICE, "/PREVIEW_ENABLED");
var GENERATE_PRESIGNED_URL = "".concat(SLICE, "/GENERATE_PRESIGNED_URL");
export var GENERATE_PRESIGNED_URL_REQUEST = "".concat(GENERATE_PRESIGNED_URL, "_REQUEST");
export var GENERATE_PRESIGNED_URL_SUCCESS = "".concat(GENERATE_PRESIGNED_URL, "_SUCCESS");
export var GENERATE_PRESIGNED_URL_FAILURE = "".concat(GENERATE_PRESIGNED_URL, "_FAILURE");
export var SET_DDU_LIST = "".concat(GENERATE_PRESIGNED_URL, "_SET_DDU_LIST");
var GET_DOWNLOAD_REPORT_URL = "".concat(SLICE, "/GET_DOWNLOAD_REPORT_URL");
export var GET_DOWNLOAD_REPORT_URL_REQUEST = "".concat(GET_DOWNLOAD_REPORT_URL, "_REQUEST");
export var GET_DOWNLOAD_REPORT_URL_SUCCESS = "".concat(GET_DOWNLOAD_REPORT_URL, "_SUCCESS");
export var GET_DOWNLOAD_REPORT_URL_FAILURE = "".concat(GET_DOWNLOAD_REPORT_URL, "_FAILURE");
var FETCH_DATA_FROM_PRESIGNED_URL = "".concat(SLICE, "/FETCH_DATA_FROM_PRESIGNED_URL");
export var FETCH_DATA_FROM_PRESIGNED_URL_REQUEST = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_REQUEST");
export var FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_SUCCESS");
export var FETCH_DATA_FROM_PRESIGNED_URL_FAILURE = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_FAILURE");
var GET_REPORT_DETAILS = "".concat(SLICE, "/GET_REPORT_DETAILS");
export var GET_REPORT_DETAILS_REQUEST = "".concat(GET_REPORT_DETAILS, "_REQUEST");
export var GET_REPORT_DETAILS_SUCCESS = "".concat(GET_REPORT_DETAILS, "_SUCCESS");
export var GET_REPORT_DETAILS_FAILURE = "".concat(GET_REPORT_DETAILS, "_FAILURE");
export var RESET_GET_REPORT_DETAILS = "".concat(SLICE, "/RESET_GET_REPORT_DETAILS");
var GET_REPORT_DETAILS_POLLING = "GET_REPORT_DETAILS_POLLING";
export var START_GET_REPORT_DETAILS_POLLING_REQUEST = "".concat(SLICE, "/START_").concat(GET_REPORT_DETAILS_POLLING, "_REQUEST");
export var STOP_GET_REPORT_DETAILS_POLLING_REQUEST = "".concat(SLICE, "/STOP_").concat(GET_REPORT_DETAILS_POLLING, "_REQUEST");
var APPROVE_REPORT = "".concat(SLICE, "/APPROVE_REPORT");
export var APPROVE_REPORT_REQUEST = "".concat(APPROVE_REPORT, "_REQUEST");
export var APPROVE_REPORT_SUCCESS = "".concat(APPROVE_REPORT, "_SUCCESS");
export var APPROVE_REPORT_FAILURE = "".concat(APPROVE_REPORT, "_FAILURE");
var REJECT_REPORT = "".concat(SLICE, "/REJECT_REPORT");
export var REJECT_REPORT_REQUEST = "".concat(REJECT_REPORT, "_REQUEST");
export var REJECT_REPORT_SUCCESS = "".concat(REJECT_REPORT, "_SUCCESS");
export var REJECT_REPORT_FAILURE = "".concat(REJECT_REPORT, "_FAILURE");
var GET_PRESIGNED_URL = "".concat(SLICE, "/GET_PRESIGNED_URL");
export var GET_PRESIGNED_URL_REQUEST = "".concat(GET_PRESIGNED_URL, "_REQUEST");
export var GET_PRESIGNED_URL_SUCCESS = "".concat(GET_PRESIGNED_URL, "_SUCCESS");
export var GET_PRESIGNED_URL_FAILURE = "".concat(GET_PRESIGNED_URL, "_FAILURE");

//# sourceMappingURL=types.js.map